import { NavLink } from "reactstrap"
import styled from "styled-components"

export const StyledNavLink = styled(NavLink)`
	display: inline-block;

	&:hover {
		cursor: pointer;
		text-decoration: underline !important;
	}
`

export const HoverText = styled.span`
    position: relative;

    &:before {
        content: attr(data-hover);
        visibility: hidden;
        opacity: 0;
        width: 140px;
        background-color: black;
        color: #fff;
        text-align: center;
        border-radius: 5px;
        padding: 5px 0;
        transition: opacity 1s ease-in-out;

        position: absolute;
        z-index: 1;
        left: 0;
        bottom: 110%;
    }

    &:hover:before {
        opacity: 1;
        visibility: visible;
    }
`

export const Grid = styled.div`
    padding-top: 20px;
    grid-auto-flow: column; 
    display: grid;
    grid-template-columns: ${({columns}) => `repeat(${columns}, 1fr)`};
    grid-column-gap: 10px;
`

export const UserStatus = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .status-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 10px 0;
        .title {
            color: #484848;
            margin-bottom: 10px;
        }
        .status {
            padding: 5px 10px;
            border-radius: 5px;
            font-weight: 600;
            &:hover {
                cursor: pointer;
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/components/Main/styled.js